import { useApiContext } from '@customink/project-service-react-components';
import { useCallback } from 'react';

import { useAuth } from '@/contexts/auth/AuthContext';

export const useGetOrCreatePortalLink = () => {
  const api = useApiContext();
  const { personalAccount } = useAuth();
  const [trigger, result, promise] =
    api.useGetOrCreateAccountTaxExemptionPortalLinkMutation({});
  const triggerWithArgsOrSkip = useCallback(async () => {
    if (!personalAccount?.id) {
      return;
    }
    return trigger({ accountId: personalAccount.id });
  }, [trigger, personalAccount?.id]);
  return [triggerWithArgsOrSkip, result, promise];
};
